import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

import { EventTypes } from 'src/app/core/constants/event-types';
import { AppPrivateNumbersFormSelectAll } from 'src/app/core/types/app-private-numbers-form-select-all.type';
import {
  BaseFormModule,
  BaseFormPageComponent,
} from 'src/app/pages/shared/base';
import { SmsSenderAgentChipListSelectSearchComponent } from 'src/app/shared/components/chip-list-select-search/sms-sender-agent-chip-list-select-search.component';
import {
  DeliveryStatus,
  GetEnumValuesDto,
  TypePrivateNumberAccesses,
} from '../../../../core/api/models';
import { NumberDto } from '../../../../core/api/models/number-dto';
import { UpdatePrivateNumberCommand } from '../../../../core/api/models/update-private-number-command';
import { RegularExpressions } from '../../../../core/constants/regular-expressions';
import { DateTimeService } from '../../../../core/services/date-time.service';
import { DateTimeConfig } from '../../../../shared/components/date-time-picker/date-time-picker.component';
import { CreatePrivateNumberCommand } from './../../../../core/api/models/create-private-number-command';
import { PrivateNumberUseForm } from './../../../../core/api/models/private-number-use-form';
import { SendPriority } from './../../../../core/api/models/send-priority';
import { PrivateNumbersService } from './../../../../core/api/services/private-numbers.service';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';

@Component({
  selector: 'app-private-numbers-form',
  templateUrl: './private-numbers-form.component.html',
  imports: [BaseFormModule, SmsSenderAgentChipListSelectSearchComponent],
  styles: [
    `
      img {
        width: -webkit-fill-available;
      }
    `,
  ],
})
export class PrivateNumbersFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  formPageConfig: FormPageConfig<NumberDto> = {};
  model: any = {};
  // expireTime;

  //#region Enums
  get PrivateNumberUseForm() {
    return PrivateNumberUseForm;
  }
  get SendPriority() {
    return SendPriority;
  }
  get TypePrivateNumberAccesses() {
    return TypePrivateNumberAccesses;
  }

  //#endregion

  singleRangeExample: string = '100031364141?';
  multipleRangeExample: string = '100030*';

  isSelectBulkSend = false;
  isSelectWebServiceSend = false;
  isSelectToNumberSend = false;
  skipChangeUseFormValidationsMethod = false;
  dateTimeConfig: DateTimeConfig;

  DeliveryStatusEnumValues: GetEnumValuesDto[] = [];
  get DeliveryStatus() {
    return DeliveryStatus;
  }
  //#endregion

  constructor(protected currentService: PrivateNumbersService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      if (!this.skipChangeUseFormValidationsMethod)
        this.changeUseFormValidations(this.model?.useForm);
      this.getEnumValuesApi('DeliveryStatus')
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((values) => (this.DeliveryStatusEnumValues = values));
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  ngAfterViewInit() {
    this.changeSelectAllByType(null, 'all', false);
  }

  setComponentsConfig() {
    try {
      this.dateTimeConfig = {
        dateLabel: 'common.expireDate',
        timeLabel: 'common.expireTime',
        dateFormControl: this.form?.get(
          'generalSettings.expireDate'
        ) as FormControl,
        timeFormControl: this.form?.get(
          'generalSettings.expireTime'
        ) as FormControl,
        minDateType: 'today',
        isDefaultValue: false,
        isConvertToIsoString: false,
        dateTimeValue: this.formPageConfig.isEditMode
          ? this.model.expireDate
          : DateTimeService.combineDateTimeToUTC(
              this.model.expireDate,
              '08:00'
            ),
        isEditMode: this.formPageConfig.isEditMode,
      };
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#region init methods

  initModel() {
    try {
      this.model = {
        useForm: 0,
        checkFilter: true,
        isAutomaticBulk: false,
        isGeneralBlackList: false,
        isPublic: false,
        isSendBulk: false,
        isSendPhonebook: false,
        isSendSingle: false,
        sendToBlackList: false,
        expireDate: DateTimeService.getAYearLaterToIsoString(),
      };

      super.initModel();
      this.setComponentsConfig();

      if (this.model.useForm === PrivateNumberUseForm.Mask) {
        this.model.mask = this.model.number;
        this.model.number = null;
        this.model.range = null;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      //اطلاعات فرستنده پیام
      messageSenderInformation: new FormGroup({
        smsSenderAgentId: new FormControl('', Validators.required),
        useForm: new FormControl('', Validators.required),
        number: new FormControl(''),
        mask: new FormControl(''),
        range: new FormControl(''),
        signature: new FormControl(''),
        header: new FormControl(''),
        numberStartOfRange: new FormControl(''),
        numberEndOfRange: new FormControl(''),
      }),
      //تنظیمات کلی
      generalSettings: new FormGroup({
        type: new FormControl('', Validators.required),
        priority: new FormControl('', Validators.required),
        expireDate: new FormControl('', Validators.required),
        expireTime: new FormControl('', Validators.required),
        price: new FormControl('', [Validators.required]),
        tag: new FormControl(''),
        description: new FormControl(''),
        tryCount: new FormControl(''),
        isActive: new FormControl(),
        sendToBlackList: new FormControl(),
        isGeneralBlackList: new FormControl(),
        deliveryBase: new FormControl(),
        checkFilter: new FormControl(),
        isPublic: new FormControl(),
        isAutomaticBulk: new FormControl(),
        isAutomaticGroup: new FormControl(),
        isSendBulk: new FormControl(),
        isSendGender: new FormControl(),
        isSendGroup: new FormControl(),
        isSendPhonebook: new FormControl(),
        isSendSingle: new FormControl(),
        isDefault: new FormControl(),
        isSendApiP2P: new FormControl(),
        isSendApiSingle: new FormControl(),
        isSendBulk2: new FormControl(),
        isSendClub: new FormControl(),
        isSendDynamic: new FormControl(),
        isSendOtp: new FormControl(),
        isSendP2P: new FormControl(),
        confirmP2pAndDynamic: new FormControl(),
        isSendDevice: new FormControl(),
        isSendSmart: new FormControl(),
        isNeedToSendConfirmationMessage: new FormControl(),
        isSendPrivateNumberExpirationMessage: new FormControl(),
        isCanSendFlashSms: new FormControl(),
        isCanSendSmartWithoutConfirmation: new FormControl(),
        isSendOccasionPhonebook: new FormControl(),
        refundDeliveryStatusId: new FormControl('', Validators.required),
      }),
    });
  }

  //#endregion

  //#region UseForm validations

  changeUseFormValidations(value) {
    try {
      this.model.useForm = value;
      //clear validation
      this.form.get('messageSenderInformation').get('number').clearValidators();
      this.form.get('messageSenderInformation').get('mask').clearValidators();
      this.form.get('messageSenderInformation').get('range').clearValidators();

      //update
      if (value === PrivateNumberUseForm.OneNumber) {
        this.form
          .get('messageSenderInformation')
          .get('number')
          .setValidators([
            Validators.required,
            Validators.pattern(RegularExpressions.justNumber),
          ]);
      } else if (value === PrivateNumberUseForm.Mask) {
        this.form
          .get('messageSenderInformation')
          .get('mask')
          .setValidators([Validators.required]);
      } else if (value === PrivateNumberUseForm.RangeNumber) {
        this.form
          .get('messageSenderInformation')
          .get('range')
          .setValidators([
            Validators.required,
            Validators.pattern(RegularExpressions.rangeNumber),
          ]);
      }

      //update
      this.form
        .get('messageSenderInformation')
        .get('number')
        .updateValueAndValidity();
      this.form
        .get('messageSenderInformation')
        .get('mask')
        .updateValueAndValidity();
      this.form
        .get('messageSenderInformation')
        .get('range')
        .updateValueAndValidity();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  setUseFormValues() {
    try {
      if (this.model.useForm == 0) {
        this.model.range = null;
        this.model.mask = null;
      } else if (this.model.useForm == 1) {
        this.model.number = null;
        this.model.range = null;
      } else if (this.model.useForm == 2) {
        this.model.number = null;
        this.model.mask = null;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  get errorControl() {
    try {
      let validateMessageSenderInformation = this.form.controls
        .messageSenderInformation as FormGroup;
      return validateMessageSenderInformation.controls;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  get errorControlSystemInformation() {
    try {
      let validateGeneralSettings = this.form.controls
        .generalSettings as FormGroup;
      return validateGeneralSettings.controls;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#endregion

  //#region Api

  //Create
  baseCreateApi(model: CreatePrivateNumberCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .privateNumbersCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdatePrivateNumberCommand) {
    this.unSubs();
    this.loading = true;

    model.id = this.formPageConfig.editId;
    this.currentService
      .privateNumbersUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);

    //  this.formPageConfig.isEditMode = false;
  }

  //#endregion

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;

      this.setUseFormValues();
      if (this.model.useForm == PrivateNumberUseForm.Mask)
        this.model.number = this.model.mask;

      this.checkCreateOrUpdate();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  changeSelectAllByType(
    event,
    className: AppPrivateNumbersFormSelectAll,
    isSelectedAllBtn: boolean
  ) {
    if (isSelectedAllBtn) this.onChangeSelectAllByType(event, className);
    else this.checkSelectAllByType(className);
  }

  isSelectAllByType(className): boolean {
    try {
      let checkBoxes = this.getCheckBoxesByType(className);
      let result: boolean = true;

      checkBoxes.forEach((item) => {
        if (result) if (!(item as HTMLInputElement).checked) result = false;
      });
      return result;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  checkSelectAllByType(type) {
    try {
      switch (type) {
        case '.bulkSend':
          this.isSelectBulkSend =
            this.model.isSendBulk2 && this.model.isSendBulk;
          break;
        case '.webServiceSend':
          this.isSelectWebServiceSend =
            this.model.isSendApiSingle &&
            this.model.isSendApiP2P &&
            this.model.isSendOtp;
          break;
        case '.toNumberSend':
          this.isSelectToNumberSend =
            this.model.isSendP2P &&
            this.model.isSendDynamic &&
            this.model.isSendClub &&
            this.model.isSendPhonebook &&
            this.model.isSendSingle;
          break;
        case 'all':
          this.isSelectBulkSend =
            this.model.isSendBulk2 && this.model.isSendBulk;

          this.isSelectWebServiceSend =
            this.model.isSendApiSingle &&
            this.model.isSendApiP2P &&
            this.model.isSendOtp;

          this.isSelectToNumberSend =
            this.model.isSendP2P &&
            this.model.isSendDynamic &&
            this.model.isSendClub &&
            this.model.isSendPhonebook &&
            this.model.isSendSingle;
          break;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  onChangeSelectAllByType(event, type) {
    try {
      const isChecked = event.checked;
      const checkBoxes = this.getCheckBoxesByType(type);
      checkBoxes.forEach((input) => {
        if ((input as HTMLInputElement).checked != isChecked)
          (input as HTMLInputElement).click();
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  getCheckBoxesByType(className) {
    try {
      return document.querySelectorAll(`${className} button`);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
}
